// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2No07","title":"Info_title__21x5D","selects":"Info_selects__Qq0Di","requiredAsterisk":"Info_requiredAsterisk__2DPUR"};